export default "__VITE_ASSET__BYJoBpNZ__"